import * as React from 'react'

import { LoginHeading } from '@ally/ally-login'

import { useTransmit } from '../../TransmitContext'
import { StyledTextBody } from '../Shared'
import { CallUsModal } from '../../Modals'

const AutoAltMfaMaxRetriesContent: React.FC = () => {
  return (
    <>
      <LoginHeading title="We can't verify your account." />

      <StyledTextBody size="sm" tag="p">
        You entered the wrong account number or VIN/Hull ID.{' '}
        <CallUsModal triggerContent="Give us a call" /> to finish setting up
        your profile.
      </StyledTextBody>
    </>
  )
}

export const AutoAltMfaMaxRetries: React.FC = () => {
  const { activeScreen } = useTransmit()

  if (activeScreen.type !== 'AutoAltMfaMaxRetries') {
    return null
  }

  return <AutoAltMfaMaxRetriesContent />
}
